import angular from 'angular';

import tszImportCsv from './tsz-import-csv';

const tszImportCsvModule = angular.module('tsz.components.tszImportCsv', [])
  .component('tszImportCsv', tszImportCsv);

export default tszImportCsvModule;



// WEBPACK FOOTER //
// ./src/components/tsz-import-csv/tsz-import-csv.module.js